// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"0c610989","208":"ebd18420","209":"35682d8c","878":"0dbe96a5"}[chunkId] + ".chunk.js";
};